export default __webpack_public_path__ + "static/media/FanOnly.1ab4a0da.svg";